import api from './api'

export default {
  buscar(body){
    const config = {
      headers: { 'Authorization': `${localStorage.getItem('tokenAuthorization')}`}
    };
    return api().post('/contato/buscar', body, config)
  },
}